import React, { useContext } from "react";
import { useState } from "react";
import { DropdownContext } from "./Categories";

// Example array of main categories with image paths
const mainCategories = [
  {
    name: "Consumer Electronics",
    src: require("../../assets/homepage/navbar/TopCategories/Consumer Electronics.png"),
  },
  { name: "Fashion & Apparel", src: require("../../assets/homepage/navbar/TopCategories/Fashion & Apparels.png") },
  { name: "Toys", src: require("../../assets/homepage/navbar/TopCategories/toys.png") },
  { name: "Sports & Entertainment", src: require("../../assets/homepage/navbar/TopCategories/Sports & Entertainment.png") },
  { name: "Home and Decor", src: require("../../assets/homepage/navbar/TopCategories/Home & Garden.png") },
  { name: "Baby care", src: require("../../assets/Baby care.png") },
  { name: "Beauty & Personal Care", src: require("../../assets/beauty.png") },
  { name: "Sustainable Products", src: require("../../assets/sustainibilityLogo.png") },
];

const CategoriesDropdown = ({ setIdx, setTitle }) => {
  const { selectedCategory, setSelectedCategory, getSubChildCategories } =
    useContext(DropdownContext);

  const handleSelectCategory = (item, index) => {
    setSelectedCategory(item.name === selectedCategory ? null : item.name); // Toggle selected main category
    setTitle(item.name);
    setIdx(index);
    getSubChildCategories(item.name);
  };

  return (
    <div>
      <div className="flex flex-col gap-y-[3px] w-[286px] h-[430px] overflow-y-auto">
        {mainCategories.map((item, index) => (
          <div
            key={index}
            className={
              "flex space-x-3 rounded" +
              (selectedCategory === item?.name
                ? " bg-[#FFE3C7] text-black font-semibold space-x-2 text-[14px]"
                : "")
            }
            onClick={() => handleSelectCategory(item, index)}
          // onClick={
          //   (() => setActiveDashBoardIndex(index),
          //   setActiveCategory(item.type))
          // }
          >
            <button
              className="flex items-center w-[286px] h-[50px] rounded"
              style={{
                background:
                  selectedCategory === item.name ? "#FFE3C7" : "transparent", // Change background color when selected
                color: selectedCategory === item.name ? "black" : "inherit", // Change text color when selected
              }}
            >
              <hr
                className={
                  selectedCategory === item.name
                    ? "bg-[#FF6300] w-[3px] h-[50px] rounded-full"
                    : ""
                }
                onClick={() =>
                  setSelectedCategory(
                    item.name === selectedCategory ? null : item.name
                  )
                }
              />
              <img
                className="w-[34px] h-[34px] rounded-full ml-[12px] mr-[8px]"
                src={item?.src}
                alt={`${item.name} Image`}
              />
              <div className="flex items-center justify-between w-[250px] text-[14px]">
                {item.name}
                <div className="text-[#c5c5c5]">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="25"
                    height="25"
                    viewBox="0 0 25 25"
                    fill="none"
                  >
                    <path
                      d="M8.54147 6.95825L13.9932 12.5061L8.44539 17.9578"
                      stroke="black"
                      strokeOpacity="0.6"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CategoriesDropdown;
